import { InMemoryObjectBase } from '../../../helpers/in-memory-object';
import { Partner } from './partner';
import { JSONUtilites } from '../../../helpers/JSONUtilites';

export class InMemoryPartners extends InMemoryObjectBase<Partner> {

  get(partnerId: number): Partner {
    return this._items.find(x => x.id === partnerId);
  }

  protected get storeKeyName(): string {
    return 'in_memory_partners';
  }

  protected _createDemoItems(): Partner[] {
    const partner1 = new Partner({ id: 1, firstName: 'Admin', lastName: '', zip: '11111', gender: 'M', dateOfBirth: new Date(1990, 8, 10), email: 'admin@admin.com', phone: '0999999', offersMedia: true, offersEmail: false, offersPhone: false, children: [], ref: 'XX00000001', waiverUrl: 'assets/docs/waiver.pdf' });
    const partner2 = new Partner({ id: 2, firstName: 'Jesica', lastName: 'Bren', zip: '12345', gender: 'F', dateOfBirth: new Date(1988, 2, 10), email: 'test@mail.com', phone: '0999999', offersMedia: true, offersEmail: false, offersPhone: false, children: [], ref: 'XX00000002', waiverUrl: 'assets/docs/waiver.pdf' });
    const partner3 = new Partner({ id: 3, firstName: 'John', lastName: 'Smith', zip: '11111', gender: 'M', dateOfBirth: new Date(1990, 8, 10), email: 'john@mail.com', phone: '0999999', offersMedia: true, offersEmail: false, offersPhone: false, children: [], ref: 'XX00000003', waiverUrl: 'assets/docs/waiver.pdf' });
    const partner4 = new Partner({ id: 4, firstName: 'Brandon', lastName: 'Bren', zip: '12345', gender: 'M', dateOfBirth: new Date(2002, 6, 3), email: '', phone: '0999999', offersMedia: false, offersEmail: false, offersPhone: false, children: [], ref: 'XX00000004', waiverUrl: 'assets/docs/waiver.pdf' });
    const partner5 = new Partner({ id: 5, firstName: 'Alise', lastName: 'Bren', zip: '12345', gender: 'F', dateOfBirth: new Date(2005, 6, 3), email: '', phone: '0999999', offersMedia: false, offersEmail: false, offersPhone: false, children: [], ref: 'XX00000005', waiverUrl: 'assets/docs/waiver.pdf' });

    return [partner1, partner2, partner3, partner4, partner5];
  }

  protected _FromJSON(json: string): Partner[] {
    return JSONUtilites.arrayFromJSON<Partner>(null, json, Partner.createFromAny);
  }

  protected _getItemId(item: Partner): number {
    return item.id;
  }
}

